import { Link } from 'react-router-dom';

import { TEntityGridColumn } from 'app/common/entity-grid/core';
import {
  OneOfFilterDataGrid,
  StringFilterDataGrid,
} from 'app/common/ui/data-grid/filters';
import { appRoute } from 'app/railways/router/routes';

import { TEmployee } from '../../core/employee';

export const cols: TEntityGridColumn<TEmployee>[] = [
  {
    field: 'id',
    // type: 'rightAligned',
    headerName: 'ID',

    // maxWidth: 100,
    flex: 1,
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      const path = appRoute.USER.DETAILS.buildPath({
        id: value,
      });

      return <Link to={path}>{value}</Link>;
    },
    filter: StringFilterDataGrid({
      filterName: 'id',
      placeholder: 'Введите ID пользователя',
    }),
  },
  {
    flex: 3,
    field: 'name',
    // type: 'rightAligned',
    headerName: 'Имя',
    minWidth: 50,
    colId: 'name',
    sortable: false,
    comparator: () => 0,
  },
  {
    flex: 2,
    field: 'login',
    // type: 'rightAligned',
    headerName: 'Логин',
    minWidth: 50,
    colId: 'login',
    sortable: false,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      const path = appRoute.USER.DETAILS.buildPath({
        id: value,
      });

      return <Link to={path}>{value}</Link>;
    },
    filter: StringFilterDataGrid({
      filterName: 'login',
      placeholder: 'Введите Логин пользователя',
    }),
  },
  {
    flex: 2,
    field: 'blocked',
    headerName: 'Статус блокировки',
    colId: 'blocked',
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: boolean }) =>
      value ? 'Заблокирован' : 'Активен',
    filter: OneOfFilterDataGrid({
      filterName: 'blocked',
      options: [
        { label: 'Заблокирован', value: 1 },
        { label: 'Активен', value: 0 },
      ],
    }),
  },
];
